export enum NoticeType {
    Error = 'Error',
    Warning = 'Warning',
    Success = 'Success',
}

export interface Notice {
    type: NoticeType;
    content: string;
}

declare global {
    interface Window {
        notices?: Notice[];
    }
}
